export default class ConsultasService {
    constructor() {
    }
}
ConsultasService.$inject = [];
